<template>
  <div class="solfigr-history-select solfhsslct">
    <GwMenu
      ref="gwmenu"
      trigger="click"
    >
      <template #opener="{ value }">
        <div
          class="gw_btn"
          style="--padding: 0 1.5rem 0 0.5rem; font-size: var(--btn-font-size)"
        >
          <div
            v-if="!item"
            style="min-width: 8rem"
          >
            <!-- {{ $t('messages.choose_solution') }} -->
          </div>
          <SolfigrHistoryItem
            v-else
            class="f-center"
            style="--hsi-card-height: 1.5rem; --min-width-players: auto"
            :item="item"
          >
          </SolfigrHistoryItem>

          <div
            class="mdi text-semi-large icon_btn transition_03 mdi-menu-down"
            :class="{ rotated_180_before: value }"
            style="transition: 0.22s; position: absolute; right: 0"
          />
        </div>
      </template>
      <template #default="{ methods }">
        <div
          v-if="history_call.loading"
          class="gw_menu f-center"
        >
          <LoaderSpinner :style="`--size:2rem`" />
        </div>
        <GwBtns
          v-else
          :options="items"
          style="--gwbtns-direction: column; max-height: 24rem"
          class="gwbtns_vertical_primary gw_menu"
          btnClass="gw_loading_text"
          :value="item ? item.id : ''"
          @click="
            (_e, item) => {
              $emit('click:item', item)
              methods.toggleOpen(false)
            }
          "
        >
          <template #default="{ item }">
            <SolfigrHistoryItem
              :item="item"
              style="--hsi-card-height: 1.5rem; --min-width-players: auto"
              class="f-center clr-white"
            />
          </template>
        </GwBtns>
      </template>
    </GwMenu>
    <div class="solfhsslct_name">
      <div
        class="truncate"
        :title="item ? item.name || name : name"
      >
        {{ item ? item.name || name : name }}
      </div>
    </div>
  </div>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import GwBtns from '@/components/lib/GwBtns'
import LoaderSpinner from '@/components/Loaders/LoaderSpinner'
import SolfigrHistoryItem from '@/components/Dialogs/Solfigr/SolfigrHistoryItem'

import float_mix from '@/mixins/float_mix'
import format_mix from '@/mixins/format_mix'
import fetch_mix from '@/mixins/fetch_mix'

export default {
  name: 'SolfigrHistorySelect',
  components: {
    SolfigrHistoryItem,
    GwMenu,
    GwBtns,
    LoaderSpinner,
  },
  mixins: [format_mix, float_mix, fetch_mix],
  props: {
    customSolutionId: { required: true, type: String },
    item: Object,
    name: String,
    historyCallId: [String, Number],
  },
  emits: ['click:item', 'loaded'],
  data() {
    return {
      history_call: {
        conf: {},
        loading: false,
        loaded: false,
        status: 0,
      },
      items: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      const params = {
        custom_solution__similar: this.customSolutionId,
      }

      // TODO when cache is ready call invalidate here instead of using historyCallId
      const callId = `poker/custom-solutions/history/${new URLSearchParams(params)}_${
        this.historyCallId
      }`

      this.history_call.conf = {
        endpoint: 'poker/custom-solutions/history/',
        waitForCache: true,
        callId,
        params,
        gwCacheId: callId,
        gwCacheAdd: true,
      }
      const { data, error } = await this.fch_getData(this.history_call)
      if (error) return
      this.items = (data.results || []).map(i => i.solution)

      this.$emit('loaded', { items: this.items })

      // this.items = getUniqueArr({
      // arr: (data.results || []).map(i => i.solution),
      // key: 'id',
      // })

      // --dev
      // this.items = (data.results || []).map(i => i.solution)
      // this.items = [...this.items, ...this.items, ...this.items]
      // this.items = [...this.items, ...this.items, ...this.items]
      // this.history_call.loading = true
    },
  },
  computed: {
    // loadingItems() {
    //   return [1, 2, 3, 4].map(id => ({
    //     id,
    //     board: 'AsAsAs',
    //     custom_tree: {
    //       players: [{ display_position: 'OOP' }, { display_position: 'IP' }],
    //     },
    //   }))
    // },
  },
}
</script>

<style lang="scss">
.solfhsslct {
  --btn-font-size: 0.875rem;
  display: flex;
  gap: 1rem;
  min-width: 0;
  // flex: 1;
  &_name {
    display: flex;
    align-items: center;
    justify-content: center;
    // max-width: 18em;
    // flex: 1;
    min-width: 0;
    // padding: 0 0.5rem;
    font-weight: 500;
    font-size: 0.875rem;
    // font-size: 1rem;
    color: var(--clr-grey-2);
  }
}
</style>
